import script from "./EmitsChildComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmitsChildComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EmitsChildComponent.vue?vue&type=style&index=0&id=4fea6b56&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fea6b56"]])

export default __exports__